<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { openModal } from 'svelte-modals';

    import ModalSelectVehicle from '../Modals/ModalSelectVehicle.svelte';
    import SelectVehicleText from './SelectVehicleText.svelte';
    import ModalInfo from '../../shared/Modals/ModalInfo.svelte';
    import IconError from '../../shared/Icons/IconError.svelte';
    import VehicleIcon from './VehicleIcon.svelte';
    import { Vehicle } from './Vehicle';
    import { vehiclesManager } from './VehiclesApp/vehiclesManager';
    import { debug } from '../../../stores/store';

    export let selected: number | null;
    export let onChange: (selected: number | null) => boolean;
    export let disabled: boolean = false;
    export let disabledText: string = '';
    export let styleMode: 'filter' | 'link' | 'standard' = 'filter';
    export let alreadyUsedVehicles: number[] = [];
    export let allowUseAlreadyUsedVehicle: boolean = true;
    export let allowToRemoveAssignment: boolean = true;
    export let vehicleColor: string = '#ffffff';
    export let prompt: string = 'select_vehicle';

    let selectedVehicle: Vehicle | null = null;
    let warnings: string[] = [];
    let warningsText: string = '';

    function addWarnings(vehicle: Vehicle | null) {
        warnings = [];
        warningsText = '';
        if (vehicle && vehicle.isActive() === false) {
            warnings.push($_('vehicle_not_confirmed_by_email'));
        }
        warnings = warnings;
        warningsText = warnings.join('\n');
    }

    onMount(async () => {
        await $vehiclesManager.asyncGetItems(null);
        selectedVehicle =
            $vehiclesManager.getItems(null).find((v: Vehicle) => v.getId() === selected) || null;
        // console.log('prepareData,SelectVehicle, onMount', selectedVehicle, selected);
        // console.log(
        //     'prepareData,SelectVehicle, $vehiclesManager.getItems().length',
        //     $vehiclesManager.getItems().map(v => v.getId())
        // );
        addWarnings(selectedVehicle);
    });

    $: {
        selectedVehicle = selectedVehicle;
        selectedVehicle =
            $vehiclesManager.getItems(null).find((v: Vehicle) => v.getId() === selected) || null;
        addWarnings(selectedVehicle);
    }

    $: {
        if (selectedVehicle !== null) {
            if (vehicleColor) selectedVehicle.setColor(vehicleColor);
            selectedVehicle = selectedVehicle;
            // console.log('SelectVehicle, selectedVehicle!==null', selectedVehicle?.getId());
        }
    }
</script>

<div style="display: flex; flex-direction: row; align-items: center; ">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="select-vehicle select-vehicle-{styleMode} {disabled ? 'disabled' : ''}"
        title={$_('Change vehicle')}
        on:click={() => {
            if (disabled && disabledText !== '') {
                openModal(ModalInfo, { text: disabledText });
            } else {
                openModal(ModalSelectVehicle, {
                    alreadyUsedVehicles,
                    allowUseAlreadyUsedVehicle,
                    allowToRemoveAssignment,
                    onClick: vehicleId => {
                        selectedVehicle =
                            $vehiclesManager.getItems(null).find(v => v.getId() === vehicleId) ??
                            null;
                        //if (vehicleId)
                        // selectedString = vehicleId === null ? '' : vehicleId.toString();
                        onChange(vehicleId);
                    },
                });
            }
        }}
    >
        <div
            style="display: flex; flex-direction: row; align-items: center; column-gap: 5px; margin-left: 0; overflow: hidden;"
        >
            {#if ['filter', 'standard'].includes(styleMode) && selectedVehicle !== null}
                <VehicleIcon vehicle={selectedVehicle} scale={0.65} />
            {:else if styleMode === 'link' && selectedVehicle !== null}
                <VehicleIcon vehicle={selectedVehicle} scale={0.65} displayMode="none" />
            {/if}
            <SelectVehicleText
                vehicleName={selectedVehicle ? selectedVehicle.getName() : null}
                {prompt}
                {styleMode}
            />
        </div>
        {#if warnings.length}
            <div style="position:absolute; right: -14px;">
                <IconError scale={0.85} title={warningsText} />
            </div>
        {/if}
    </div>
</div>

<style>
    :global(.input-small) {
        width: 200px;
    }
    .error {
        border: 1px solid #cb0936;
        color: white;
        background-color: #cb093644;
    }
    .select-vehicle {
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        column-gap: 5px;
        font-size: inherit;
        justify-content: space-between;
        padding: 0 0 0 5px;
    }
    .select-vehicle-text {
        max-width: 160px;
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .select-vehicle-filter {
        width: 160px;
    }
    .select-vehicle-standard {
        width: 300px;
    }
    .select-vehicle-link:hover {
        color: var(--automapa-blue);
        text-decoration: underline;
    }
    .disabled {
        /*cursor: not-allowed;*/
        color: #b0b0b0;
        /* block events */
        pointer-events: none;
    }
</style>
